'use strict';

var MarketAnalysisDemandAdjustmentDirective = function MarketAnalysisDemandAdjustmentDirective() {
  return {
    restrict: 'E',
    template: require('../templates/market-analysis-demand-adjustment.html'),
    replace: true,
    controller: 'MarketAnalysisDemandAdjustmentController',
    link: function link($scope, element) {
      element.find('.help-icon').popover();
    }
  };
};
MarketAnalysisDemandAdjustmentDirective.$inject = [];
module.exports = MarketAnalysisDemandAdjustmentDirective;